import { useEffect, useState } from "react";
import "./InativarMotivoDefeitoModal.css";

export default function InativarMotivoDefeitoModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function handleOk() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao inativar.");
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="ptinv-bg" onClick={onClose}>
      <div className="ptinv-box" role="dialog" aria-modal="true" aria-label="Inativar motivo" onClick={(e) => e.stopPropagation()}>
        <header className="ptinv-head">
          <h3 className="ptinv-title">Inativar</h3>
          <button className="ptinv-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>
            x
          </button>
        </header>

        <div className="ptinv-body">
          Deseja <strong>inativar</strong> "{titulo || "este motivo"}"?
          {err ? <div className="ptinv-err">{err}</div> : null}
        </div>

        <footer className="ptinv-foot">
          <button className="ptinv-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ptinv-btn ptinv-btn-warn" type="button" onClick={handleOk} disabled={busy}>
            {busy ? "Inativando..." : "Inativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}

